interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: boolean;
  dark?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, accent = false, dark = false }: SectionHeadingProps) {
  return (
    <div className="flex flex-col items-start gap-3">
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium tracking-wide ${
          accent ? "bg-accent-500 text-foreground-950" : "bg-secondary-100 text-secondary-800"
        }`}
      >
        <i className={`${accent ? "ri-flashlight-fill" : "ri-radar-line"} text-sm`} aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold leading-tight tracking-tight ${
          dark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm md:text-base leading-relaxed ${dark ? "text-background-100/80" : "text-foreground-600"}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}